import { useMemo } from 'react';
import type { Surgery } from './model/surgery';
import type { PostopSurgeryInfo } from './postop/surgeryInfo/postopSurgeryInfo.model';
import type { SurgeryInfo } from './surgeryInfo/surgeryInfo.model';

export const useUnifiedSurgeries = (
  surgeryInfo?: SurgeryInfo | PostopSurgeryInfo,
  fieldName:
    | 'combinedOrderedSurgeries'
    | 'combinedOrderedOriginalSurgeries' = 'combinedOrderedSurgeries'
) =>
  useMemo(
    () =>
      surgeryInfo?.[fieldName]?.map(
        (wr, index) =>
          wr.entity ??
          ({
            id: `USER_DEFINED_${wr.userDefined}_${index}`,
            code: wr.userDefined,
            translationCode: wr.userDefined,
            severity: 'NOT_APPLICABLE' as const
          } as Surgery)
      ) ?? [],
    [surgeryInfo, fieldName]
  );
